// extracted by mini-css-extract-plugin
module.exports = {"faxDetails":"styles_faxDetails__2FknY","detailsBorder":"styles_detailsBorder__23kjI"};